import { userList, userUpdate } from '@/services/api-v3/user';
import { useModel, useRequest } from '@umijs/max';
import { useState } from 'react';

export default () => {
  const initialState = useModel('@@initialState');
  const [data, setData] = useState<API.User[] | null>(null);
  const [valueEnum, setValueEnum] = useState<Record<string, string> | null>(
    null,
  );
  const [valueOptions, setValueOptions] = useState<
    { label: string; value: string }[] | null
  >(null);

  const updater = useRequest(userUpdate, {
    manual: true,
    onSuccess: () => {
      initialState.refresh();
    },
    formatResult: (res) => res,
  });

  const fetchList = async () => {
    const res = await userList({
      pageSize: -1,
      filter: JSON.stringify({ role: 'admin' }),
    });
    setData(res.data);
    setValueEnum(
      res.data?.reduce(
        (pre: Record<string, string>, curr: API.User) => ({
          ...pre,
          [curr.id]: curr.name,
        }),
        {},
      ),
    );
    setValueOptions(res.data?.map((d) => ({ value: d.id, label: d.name })));
  };

  const resetList = () => {
    setData(null);
    setValueEnum(null);
    setValueOptions(null);
  };

  return {
    profile: initialState?.initialState?.user,
    isAdminRole: ['admin', 'super_admin'].includes(
      initialState?.initialState?.user?.role ?? '',
    ),
    session: initialState?.initialState?.session,
    refresh: initialState.refresh,
    updater,
    fetchList,
    resetList,
    data,
    valueEnum,
    valueOptions,
  };
};
